import script from "./OneVrHomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./OneVrHomeView.vue?vue&type=script&setup=true&lang=js"

import "./OneVrHomeView.vue?vue&type=style&index=0&id=4bec91b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bec91b4"]])

export default __exports__